/**
 * @generated SignedSource<<7784d4453d162b4f66b3c1b0943b34a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useShowIncludedLabelsInline_displayPrice$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"useItemPriceData_displayPrice">;
  readonly " $fragmentType": "useShowIncludedLabelsInline_displayPrice";
}>;
export type useShowIncludedLabelsInline_displayPrice$key = ReadonlyArray<{
  readonly " $data"?: useShowIncludedLabelsInline_displayPrice$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShowIncludedLabelsInline_displayPrice">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "useShowIncludedLabelsInline_displayPrice",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useItemPriceData_displayPrice"
    }
  ],
  "type": "ItemDisplayPriceType",
  "abstractKey": null
};

(node as any).hash = "cad3d9a22b45216d4c351d405bb2faec";

export default node;
